<div class="inline-flex flex-col">
    <div class="dscr-row header">
        <div class="dscr-cell lendio-industry-label header">DSCR</div>
        @for (summary of dscrGlobalSummary(); track $index) {
            <div class="dscr-cell lendio-industry-annual">{{ summary.year }}</div>
        }
    </div>
    <div class="lendio-industry-dscr">
        @for (label of globalDscrLabels; track label; let last = $last) {
            <div class="dscr-row" [class.last]="last">
                <div class="dscr-cell lendio-industry-label">{{ label | camelToSentence }}</div>
                @for (summary of dscrGlobalSummary(); track $index) {
                    @if(label !== 'globalDscr') {
                        <div class="dscr-cell lendio-industry-annual">{{ summary[label] | currency }}</div>
                    } @else {
                        <div class="dscr-cell lendio-industry-annual">{{ summary[label] | number: '0.2-2'  }}</div>
                    }
                }
            </div>
        }
    </div>
    <mat-accordion [multi]="false" class="mt-4">
        @for (product of dscrProducts(); track product.productId) {
            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex justify-between items-center w-full">
                            <div class="flex items-center gap-2">
                                <mat-icon class="status-icon" [appDscrProductStatusIcon]="product"/>
                                <div class="title-medium">{{ product.lenderName }}</div>
                                <div class="body-medium">{{ product.productName }}</div>
                            </div>
                            <div class="flex items-center gap-2">
                                @if (product.approval) {
                                    <a class="flex items-center justify-center"
                                       [routerLink]="['/deals/', product.approval.dealId]">
                                        <mat-icon class="approval-icon">check_circle</mat-icon>
                                    </a>
                                        <div class="title-small">{{ product.approvalMeta.maxAmount | currency }}</div>
                                        <div class="body-medium">
                                            ({{ product.approvalMeta.maxAmount / product.approvalMeta.maxOption.payments | currency }}
                                            {{ product.approvalMeta.maxOption.paymentFrequency }})
                                        </div>
                                } @else {

                                    <div class="title-small">{{ product.maxNewLoanAmount | currency }}</div>
                                    <div class="body-medium">({{ product.maxNewLoanPayment | currency }} monthly)</div>
                                }
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *matExpansionPanelContent>
                    <div class="inline-flex flex-col">
                        <div class="dscr-row header lender-dscr">
                            <div class="dscr-cell product-label"></div>
                            <div class="dscr-cell product-annual">Required</div>
                            @for (result of product.productDscrResults; track $index) {
                                <div class="dscr-cell product-annual">{{ result.year }}</div>
                            }
                        </div>
                        <div class="dscr-row">
                            <div class="dscr-cell product-label">Business DSCR</div>
                            <div class="dscr-cell product-annual">{{ product.minDscrRatios.business }}</div>
                            @for (result of product.productDscrResults; track $index) {
                                <div class="dscr-cell product-annual"
                                     [ngClass]="result.meetsRequiredBusinessRatio
                                        ? 'is-passing'
                                        : 'is-failing'">
                                    {{ result.businessDscrValue }}
                                </div>
                            }
                        </div>
                        <div class="dscr-row">
                            <div class="dscr-cell product-label">Global DSCR</div>
                            <div class="dscr-cell product-annual">{{ product.minDscrRatios.global }}</div>
                            @for (result of product.productDscrResults; track $index) {
                                <div class="dscr-cell product-annual"
                                     [ngClass]="result.meetsRequiredGlobalRatio
                                        ? 'is-passing'
                                        : 'is-failing'">
                                    {{ result.globalDscrValue }}
                                </div>
                            }
                        </div>
                    </div>

                </div>
            </mat-expansion-panel>
        }
    </mat-accordion>
</div>
